import { Head, Link } from "@inertiajs/react"
import { AdminShell } from "@/components/AdminShell"
import { LifetimeDealForm } from "@/components/LifetimeDealForm"
import { PageHeader } from "@/components/PageHeader"

export default function AdminLifetimeDealNew() {
  return (
    <>
      <Head title="New Lifetime Deal">
        <meta name="description" content="Create a new Flywrite lifetime deal with its own checkout URL." />
        <meta property="og:title" content="New Lifetime Deal" />
        <meta property="og:description" content="Create a new Flywrite lifetime deal with its own checkout URL." />
      </Head>
      <AdminShell>
        <PageHeader
          title="New Lifetime Deal"
          description="One-time purchase, one seat, valid forever."
          actions={
            <Link href="/admin/lifetime_deals" className="text-sm text-ink-muted no-underline hover:text-ink-display">
              Back to deals
            </Link>
          }
        />
        <LifetimeDealForm action="/admin/lifetime_deals" method="post" submitLabel="Create deal" />
      </AdminShell>
    </>
  )
}
